import { TInitialState } from '~/src/features/tariffBuilder/reducer';
import selectCurrentTariff from '~/src/features/tariffBuilder/selectors/selectCurrentTariff';
import selectIsAllowToShowTvPackets from '~/src/features/tariffBuilder/selectors/selectIsAllowToShowTvPackets';


const selectIsShowTvBlock = (state: TInitialState) => {
    const isAllowToShowTvPackets = selectIsAllowToShowTvPackets(state);
    const currentTariff = selectCurrentTariff(state);

    return isAllowToShowTvPackets || !currentTariff;
};

export default selectIsShowTvBlock;


